<ng-container *tcsLoadUntil="!(loaderContext$ | async); context: loaderContext$ | async">
  <br />
  <p>{{ error }}</p>
</ng-container>
